import { useState } from 'react';
import { Button, Form, Input, notification } from 'antd';
import { login } from '../../controller/Control';
import {Link, useNavigate} from 'react-router-dom';
import Logo from '../../assets/logo.png'

type FieldType = {
	email?: string;
};

const ResetPassword: React.FC = () => {
   const navigate = useNavigate()

   const handleSubmit = async (values: any) => {
        const response = await login(`${process.env.REACT_APP_API_SERVER}/users/reset-password-request` || 'localhost:3000', values)
        console.log(response)
        if (response.message === 'Reset password email sent') {
           notification.success({ message: 'Verifique su correo para más instrucciones' });
        } else {
            notification.error({ message: 'Error reseteo de contraseña' });
        }   
    };

   return (
        <div className={`flex w-screen h-screen flex-col justify-center gap-1 items-center homePage`}>
            <div className='border-2 border-red-300 p-10 rounded-xl bg-[rgba(255,203,219,0.5)]'>
                <div className='flex justify-center'>
                    <img className='h-32' src={Logo}/>
                </div>
                <div>
                    <Form
                        name="login"
                        layout='vertical'
                        onFinish={handleSubmit}
                        autoComplete="off"
                    >
                        <Form.Item<FieldType>
                            label="E-Mail"
                            name="email"
                            rules={[{ type: "email", required: true, message: 'Por favor escribe un correo' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item className='mt-2'>
                            <Button type="primary" htmlType="submit">
                                Restablecer
                            </Button>
                        </Form.Item>
                        <Form.Item className='mt-2'>
                            <Button type="dashed" htmlType="button" onClick={() => navigate('/')}>
                                Cancelar
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
   );
}

export default ResetPassword
